<ng-container *transloco="let t">
  <app-page-template>
    <div class="upper-section">
      <div class="upper-section-background image-fade-in" [@fadeInAnimation]="'in'"></div>
      <div class="content-wrapper d-block d-md-flex justify-content-center align-items-center px-4">
        <ng-container [ngSwitch]="paymentComponentState">
          <div *ngSwitchDefault>
            <app-form-card>
              <h1 class="text-uppercase pb-5 text-center">{{t('app.pay.basic.data')}}</h1>
              <form #payForm="ngForm">
                <div class="container">
                  <div class="row">
                    <div class="col-12 col-xl-6">
                      <div class="form-floating mb-3">
                        <input type="text" id="firstName" class="form-control"
                          [ngModel]="currentUserDetails?.firstname ?? ''" name="firstName" readonly />
                        <label for="firstName">{{t('app.common.first.name')}}</label>
                      </div>
                    </div>
                    <div class="col-12 col-xl-6">
                      <div class="form-floating mb-3">
                        <input type="text" id="lastName" class="form-control"
                          [ngModel]="currentUserDetails?.lastname ?? ''" name="lastName" readonly />
                        <label for="lastName">{{t('app.common.last.name')}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-xl-6">
                      <div class="form-floating mb-3">
                        <input type="email" id="email" class="form-control" [ngModel]="currentUserDetails?.email ?? ''"
                          name="email" readonly />
                        <label for="email">{{t('app.common.email')}}</label>
                      </div>
                    </div>
                    <div class="col-12 col-xl-6">
                      <div class="form-floating mb-3">
                        <input type="text" id="mobilePhone" class="form-control"
                          [ngModel]="currentUserDetails?.phoneNumber ?? ''" name="mobilePhone" readonly />
                        <label for="mobilePhone">{{t('app.common.mobilePhone')}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-xl-6">
                      <div class="form-floating mb-3">
                        <input type="text" id="address" class="form-control"
                          [ngModel]="currentUserDetails?.address ?? ''" name="address" readonly />
                        <label for="address">{{t('app.common.address')}}</label>
                      </div>
                    </div>
                    <div class="col-12 col-xl-6">
                      <div class="form-floating mb-3">
                        <input type="text" id="placeOfResidence" class="form-control" [ngModel]="currentUserDetails?.city
                ?? ''" name="placeOfResidence" readonly />
                        <label for="placeOfResidence">{{t('app.common.placeOfResidence')}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-xl-6">
                      <div class="form-floating mb-3">
                        <input type="text" id="zip" class="form-control" [ngModel]="currentUserDetails?.zip
                ?? ''" name="zip" readonly />
                        <label for="zip">{{t('app.common.zip')}}</label>
                      </div>
                    </div>
                    <div class="col-12 col-xl-6">
                      <div class="form-floating mb-3">
                        <select disabled name="country" id="country" class="form-select">
                          @for(country of countries; track country){
                          <option [value]="country.id" [selected]="country.id == currentUserDetails?.country">
                            {{country.name}}
                          </option>
                          }
                        </select>
                        <label for="country">{{t('app.common.country')}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      @if(paymentComponentState === paymentComponentStateType.ERROR){
                        <div class="pt-4">
                          <span class="error-message">{{t('app.pay.error')}}</span>
                        </div>
                      }
                      <div class="pt-4">
                        <app-button [label]="t('app.pay.race')" (onClick)="onPay()"
                          [btnClass]="'btn-primary-red btn-large'" />
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="pt-4 text-center" (click)="toHome()">
                        <span class="link-button ps-2">{{t('app.common.go.to.dashboard')}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </app-form-card>
          </div>
        </ng-container>
      </div>
    </div>
  </app-page-template>
</ng-container>